<template>
  <el-dialog
    title="指标管理"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="140px">
        <el-form-item label="事项名称">
          <el-select
            style="width: 356px;"
            v-model="formInline.ghEventTypeId"
            placeholder="请选择"
            :disabled="formInline.id ? true : false"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="`${item.sxmc}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指标名称" prop="zbmc">
          <el-input
            style="width: 356px;"
            v-model="formInline.zbmc"
            placeholder="指标名称"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="eventEditFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { editAndModifyPointRel } from "@/api/base.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },

    typeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dataRadio: "1",
      mapVisible: false,
      formInline: {
        ghEventTypeId: "",
        state: "",
        zbmc: "",
        zrrlx: "街道人员",
        id: "",
        tjDeptId: "",
        extendGzUseRuleTable: "",
        dayTimes: "",
        ksWeekTimes: "",
        extendRangeMetre: null,
        extendLongitude: null,
        extendLatitude: null,
        extendAddress: null
      },
      // zrrlxOptions: [],
      extendTimeRangeList: [
        {
          time: null
        }
      ],
      deptList: [],
      useRuleList: [],
      curSource: {
        text: "",
        value: ""
      },
      picFilesJson: [],

    };
  },
  created() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
  },
  methods: {
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
    async eventEditFun() {
      if (!this.formInline.zbmc) return this.$message.error('请输入指标名称');
      let params = {
        ghEventManageId: this.formInline.ghEventTypeId,
        zbmc: this.formInline.zbmc,
        id: this.formInline.id,
      };
      const res = await editAndModifyPointRel(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}
/deep/.el-upload__input {
  display: none;
}
/deep/.avatar-uploader {
  display: flex;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/sxzbManage/components/issuesDialog.vue